import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { setMaintenance } from './maintenance.actions';

export interface MaintenanceState {
    active: boolean;
}

export const defaultState: MaintenanceState = {
    active: false,
};

export default reducerWithInitialState(defaultState).case(setMaintenance, (_, payload) => ({
    active: payload,
}));
